import React, { useState, useEffect } from "react";
import "./Minister.css";
import api, { baseURL } from "../api";
import { useTranslation } from "react-i18next";
 
const Minister = () => {
  const [ministers, setMinisters] = useState([]);
  const { i18n } = useTranslation();
 
  const fetchMinisters = async () => {
    try {
      const response = await api.get(`/minister-details?lang=${i18n.language}`);
      setMinisters(response.data);
    } catch (error) {
      console.error("Error fetching ministers:", error);
    }
  };
 
  useEffect(() => {
    fetchMinisters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language]);
 
  return (
    <div className="container-fluid" id="minister">
      <div className="row home-carousel-section">
        <div className="col-12">
          <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-xl-5 g-4 mt-3 mb-3 text-center">
            {ministers.map((minister, index) => (
              <div key={minister.id} className="col">
                <div data-aos={index % 2 === 0 ? "fade-right" : "fade-left"}>
                  <ProfileCard
                    name={minister.officer_name}
                    position={minister.designation}
                    image={`${baseURL}/${minister.image_path}`}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
 
const ProfileCard = ({ name, position, image }) => {
  return (
    <div className="minister-profile">
      <img src={image} alt={name} className="minister-photo" />
      <h6 className="minister-name">{name}</h6>
      <p className="minister-designation">{position}</p>
    </div>
  );
};
 
export default Minister;